import { MatDialogRef } from '@angular/material';
var FirmwareUpdateDialogV2Component = /** @class */ (function () {
    function FirmwareUpdateDialogV2Component(dialogRef) {
        this.dialogRef = dialogRef;
        this.dontShowAgain = false;
    }
    FirmwareUpdateDialogV2Component.prototype.close = function () { this.dialogRef.close(this.dontShowAgain); };
    return FirmwareUpdateDialogV2Component;
}());
export { FirmwareUpdateDialogV2Component };
